import { Link } from "react-router-dom";
import Icon from "@/components/icon";
import type { VitrinCourseDetailLesson } from "@/models/course/VitrinCourseDetail";

type Props = {
  miniAppUuid: string;
  courseId: string | number;
  nextLesson?: VitrinCourseDetailLesson;
  previousLesson?: VitrinCourseDetailLesson;
  /**
   * Layout of the pair. The default spreads them across the floating bar at the
   * foot of the phone screen; the desktop header packs them together instead.
   */
  className?: string;
};

const buildLessonHref = (
  courseId: string | number,
  lessonId: string | number,
  miniAppUuid: string,
) => `/course/${courseId}/lesson/${lessonId}?miniAppUuid=${encodeURIComponent(miniAppUuid)}`;

export default function LessonNavigation({
  miniAppUuid,
  courseId,
  nextLesson,
  previousLesson,
  className = "flex w-full items-center justify-between",
}: Props) {
  return (
    <div className={className}>
      {previousLesson ? (
        <Link
          to={buildLessonHref(courseId, previousLesson.id, miniAppUuid)}
          replace={true}
          className="pointer-events-auto flex items-center justify-center gap-0.5 rounded-full bg-background px-4 py-2 text-sm font-medium shadow-card transition-colors lg:hover:bg-content2"
        >
          <Icon name="chevron-right" className="size-4" />
          جلسه قبلی
        </Link>
      ) : (
        <div />
      )}

      {nextLesson ? (
        <Link
          to={buildLessonHref(courseId, nextLesson.id, miniAppUuid)}
          replace={true}
          className="pointer-events-auto flex items-center justify-center gap-0.5 rounded-full bg-background px-4 py-2 text-sm font-medium shadow-card transition-colors lg:hover:bg-content2"
        >
          جلسه بعدی
          <Icon name="chevron-right" className="size-4 rotate-180" />
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
}
